var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70729 11.25L6 9.3277L2.29271 11.25L3.00071 7.1795L0 4.29571L4.14635 3.70236L6 0L7.85365 3.70236L12 4.29571L8.99929 7.1795L9.70729 11.25Z",
    fill: "#F19D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStarIcon);
export default __webpack_public_path__ + "static/media/full-star-icon.c623cbfcf4b5ecf423d8603ea5ab93bb.svg";
export { ForwardRef as ReactComponent };